import { ca } from '@cian/analytics';

export type TReliableLabel = 'flats_reliable_dev' | 'flats_problem_building';

export function trackOffersReliableLabelClick(label: TReliableLabel) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label,
    useLastProducts: true,
  });
}
